export const en = {
  language_netherlands: 'Dutch',
  language_french: 'French'
}

export const fr = {
  language_netherlands: 'Néerlandais',
  language_french: 'Français'
}

export const nl = {
  language_netherlands: 'Nederlands',
  language_french: 'Frans'
}
